var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$isPc && _vm.$route.path !== '/install' )?_c('ok-header'):_vm._e(),_c('router-view'),(_vm.$mode == 1 && !_vm.$isPc && _vm.$route.path !== '/install')?_c('ok-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }